import { StudentProblemResult } from '@yandex-int/k-common/typings';
import { Text } from 'platform-components';
import React from 'react';

export const AttemptsCounter = ({ studentProblemResult }: { studentProblemResult: StudentProblemResult }) => {
    return (
        <Text
            id="studentLessonStat.spentAttempts.value"
            values={{
                type: studentProblemResult.type,
                number: studentProblemResult.attempt_number || 0,
                max: studentProblemResult.max_attempts,
            }}
            weight={Text.WEIGHT.L}
        />
    );
};
